import { render } from "./PendingOrders.vue?vue&type=template&id=8e9690d8"
import script from "./PendingOrders.vue?vue&type=script&lang=js"
export * from "./PendingOrders.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/tom/tom/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__